import React, { Component } from 'react'
import PropTypes from 'prop-types'
import InitPasswordPanel from './form/InitPasswordPanel'
import { Toastr, Wait } from 'react-aquasys'
import AppStore from '../../store/AppStore' 
import { connect } from 'react-redux'
import InitPasswordAction from '../actions/InitPasswordAction'
import Snackbar from '@material-ui/core/Snackbar'

class InitPasswordApp extends Component {

	constructor(props) {
		super(props)
	}

	putMessage = (value) => {
		AppStore.dispatch(InitPasswordAction.addMessage(value))
	}

	handleRequestClose = () => {
		AppStore.dispatch(InitPasswordAction.resetMessage())
	}

	render() {
		return (
			<div id='login-page'>
				<div className='container-div valign-wrapper'>
					<div className='container-panel'>
						<div className='container'>
							<div className='row'>
								<div className='col s6 m6 l4 offset-m3 offset-l4'>
									<div className='row'>
										<InitPasswordPanel putMessage={ this.putMessage }/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<Toastr store={ AppStore }/>
				<Snackbar
					open={ this.props.open }
					message={ this.props.message }
					autoHideDuration={ 2000 }
					onRequestClose={ this.handleRequestClose }
					bodyStyle={ { backgroundColor: '#FF0000', color: 'white' } }
					style={ { backgroundColor: '#FF0000', color: 'white' } }
					contentStyle={ { backgroundColor: '#FF0000', color: 'white' } }
				/>
				<Wait/>
			</div>
		)
	}
}

InitPasswordApp.propTypes = {
	open: PropTypes.bool,
	message: PropTypes.string
}
const mapStateToProps = (props) => {
	return {
		open: props.InitPasswordReducer.open,
		message: props.InitPasswordReducer.message,
		error: props.InitPasswordReducer.error
	}
}
export default connect(mapStateToProps)(InitPasswordApp)



// WEBPACK FOOTER //
// ./src/initPassword/components/InitPasswordApp.js